(function () {
  const outingEventsHandicapsApp = function () {
    const bindNaHandicaps = () => {
      $('.na-hdcp').on('change', function () {
        if (!$(this).prop('checked')) return;

        $(this).closest('tr').find('input[type=number]').val('');
      });
    };

    const bindChangeInputs = () => {
      $("[name*='usgas['], [name*='handicaps[']").on('change', function () {
        const thisUsga = $(this).attr('name').includes('usga');
        const scope = $(this).parent().parent();

        if (thisUsga) $(scope).find('input:not([name*=usga])').val('');
        else $(scope).find('input[name*=usga]').val('');
      });
    };

    $(document).on('turbolinks:load', () => {
      if (!$('body').hasClass('controller-outings-handicaps')) return;

      bindNaHandicaps();
      bindChangeInputs();
    });
  };

  if (typeof window !== 'undefined') {
    window.outingEventsHandicapsApp = outingEventsHandicapsApp();
  }
})();
